import { getServer } from 'helpers/get-server';
import { logout as logoutFromWebSocket } from 'services/web-socket/actions/logout';

export async function logout(): Promise<void> {
  await logoutFromWebSocket();
  getServer().disconnect();
}
